export default "__VITE_ASSET__CCronmw9__"